// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__4QMuv","label":"Checkbox_label__qkcn-","input":"Checkbox_input__lNrIc","checkbox":"Checkbox_checkbox__L9DDX","invalid":"Checkbox_invalid__6c+6x"};